const extractCorrectOptions = questions => {
    let correctOptions = []
    for (let i=0; i<10; i++) {
        correctOptions.push(questions[i].options[0])
    }
    return correctOptions
}

export default extractCorrectOptions